import { inputResult } from "../Submit/SaveAnswer";


export function transformIfToResult(input:JQuery, results:inputResult, points:number, possible:number){
    
    input.prop('readonly', true);
    input.attr('value', results.answer);
    if (results.right === 1){
        input.addClass("is-valid");
    } else {
        input.addClass("is-invalid");
        input.attr('title', 'Richtige Antwort: ' + results.correct);
    }

}